// External modules
import React from 'react';

// Internal modules
import {
  PrimaryResidentialAddress,
  usePrimaryResidentialAddressValue,
} from './PrimaryResidentialAddress';
import { features } from '@/lib';
import {
  LazyCRSForm,
  LazyKanaAndKanjiNames,
  LazyKYCFields,
} from './Components';
// @ts-expect-error untyped-import
import { LazyPasswordInput } from './PasswordInput';
import { getPasswordMaxLength } from './PasswordInput/passwordConstants';
import { LegalDisclosures } from './LegalDisclosures';
import { passwordContainerStyleOverrides } from './styles';
import { formInputHandlers } from '@/components/Form/formInputHandlers';
import { StreamlineLegalDisclosures } from './LegalDisclosures/StreamlineLegalDisclosures';

type SignupFieldsProps = {
  isPasswordless?: boolean;
  isStreamlineExperience?: boolean;
};

export const SignupFields = (props: SignupFieldsProps): JSX.Element | null => {
  const { isStreamlineExperience, isPasswordless } = props;
  const { changeHandler } = formInputHandlers;

  const restProps = {
    ...formInputHandlers,
    ...props,
  };

  const SelectedLegalDisclosures = isStreamlineExperience
    ? StreamlineLegalDisclosures
    : LegalDisclosures;

  const shouldShowCRSTaxCollectionSection = features.isActive(
    'shouldShowCRSTaxCollectionSection',
  );

  // Reads Elmo treatment to render Primary Residential Address
  const primaryResidentialAddressValue = usePrimaryResidentialAddressValue();

  return (
    <>
      {!isPasswordless && (
        <LazyPasswordInput
          containerStyleOverrides={passwordContainerStyleOverrides}
          data-testid="lazy-password-input"
          maxLength={getPasswordMaxLength()}
          {...restProps}
        />
      )}
      <LazyKYCFields {...restProps} />
      {features.isActive('shouldDisplayJpKanaAndKanjiNames') && (
        <LazyKanaAndKanjiNames />
      )}

      {primaryResidentialAddressValue && (
        <PrimaryResidentialAddress value={primaryResidentialAddressValue} />
      )}

      {shouldShowCRSTaxCollectionSection && <LazyCRSForm />}

      <SelectedLegalDisclosures
        changeHandler={changeHandler}
        isPasswordless={isPasswordless}
        type="signup"
      />
    </>
  );
};
